import * as overrideStages from "./overrideStageKeys";

const overrideTerminalStages = [
  overrideStages.COMPLETED,
  overrideStages.DISCARDED,
  overrideStages.FAILED,
  overrideStages.DISCARD_FAILED
];

export default overrideTerminalStages;
